import { render } from "./ProductsView.vue?vue&type=template&id=5d70eff9&scoped=true"
import script from "./ProductsView.vue?vue&type=script&lang=js"
export * from "./ProductsView.vue?vue&type=script&lang=js"

import "./ProductsView.vue?vue&type=style&index=0&id=5d70eff9&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d70eff9"]])

export default __exports__